import { motion } from "framer-motion";

export default function GlassCard({
  children,
  className = "",
  hover = true,
  onClick,
  as = "div",
}) {
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={`
        relative overflow-hidden
        bg-white/80 backdrop-blur-xl
        border border-white/20
        rounded-2xl shadow-glass
        ${hover ? "cursor-pointer" : ""}
        ${className}
      `}
      whileHover={
        hover
          ? {
              y: -8,
              scale: 1.02,
              boxShadow: "0 20px 60px -15px rgba(0, 0, 0, 0.15)",
            }
          : {}
      }
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 20,
      }}
      onClick={onClick}
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-transparent pointer-events-none" />

      {/* Content */}
      <div className="relative z-10">{children}</div>
    </Component>
  );
}

export function GlassCardDark({
  children,
  className = "",
  hover = true,
}) {
  return (
    <motion.div
      className={`
        relative overflow-hidden
        bg-dark-900/80 backdrop-blur-xl
        border border-white/10
        rounded-2xl shadow-glass
        ${hover ? "cursor-pointer" : ""}
        ${className}
      `}
      whileHover={
        hover
          ? {
              y: -8,
              scale: 1.02,
              boxShadow: "0 20px 60px -15px rgba(16, 185, 129, 0.2)",
            }
          : {}
      }
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 20,
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-transparent to-transparent pointer-events-none" />
      <div className="relative z-10">{children}</div>
    </motion.div>
  );
}
